<template>
    <div class="zoomable-img-wrap" :class="wrapClass" @click="open = true">
        <img loading="lazy" :class="imgClass" :src="src" :alt="alt"/>
        <div class="zoomable-img-badge">
            <v-icon size="14">mdi-magnify-plus-outline</v-icon>
        </div>
    </div>

    <v-dialog v-model="open" fullscreen transition="fade-transition" scrim="black">
        <div class="zoomable-img-overlay" @click.self="open = false">
            <v-btn class="zoomable-img-close" icon="mdi-close" variant="flat" density="comfortable" @click="open = false"/>
            <img :src="src" :alt="alt" class="zoomable-img-full"/>
        </div>
    </v-dialog>
</template>

<script>
export default {
    name: "ZoomableImage",
    props: {
        src: { type: String, required: true },
        alt: { type: String, default: "" },
        imgClass: { type: String, default: "" },
        wrapClass: { type: String, default: "" },
    },
    data() {
        return {
            open: false,
        };
    },
};
</script>

<style scoped>
.zoomable-img-wrap {
    position: relative;
    display: inline-block;
    cursor: zoom-in;
}
.zoomable-img-badge {
    position: absolute;
    bottom: 6px;
    left: 6px;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background: rgba(0,0,0,0.55);
    backdrop-filter: blur(2px);
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: none;
}
.zoomable-img-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0,0,0,0.92);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 3000;
}
.zoomable-img-full {
    max-width: 92vw;
    max-height: 92vh;
    object-fit: contain;
    border-radius: 8px;
}
.zoomable-img-close {
    position: absolute;
    top: calc(12px + env(safe-area-inset-top));
    left: 12px;
    background: rgba(255,255,255,0.15) !important;
    color: #fff !important;
}
</style>
